import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Grid,
    InputAdornment,
    MenuItem,
    TextField,
    Typography
} from "@mui/material";
import {useTranslation} from "react-i18next";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMore";
import {Controller, useFormContext} from "react-hook-form";
import {CURRENCY_REG_EXP} from "../Constants";
import {checkValueWithInterval} from "../Utils";
import { useTaxConfigurationAccordionValues } from "../useTaxConfigurationAccordionValues";
interface TaxConfigurationAccordionProps {
    prefix:string
}

const TaxConfigurationAccordion = ({prefix}:TaxConfigurationAccordionProps) => {
    const {t} = useTranslation(['salesmarketing'], {keyPrefix: 'taxConfiguration'});
    const {control,setValue,watch} = useFormContext();
    const {reservationValues,surchargesValues} = useTaxConfigurationAccordionValues();

    return (
        <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreRoundedIcon/>}>
                <Typography>{t('title')}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={2}>
                    <Grid item xs={3}>
                        <Controller
                            control={control}
                            name={`${prefix}.railwayStationTax`}
                            render={({field,fieldState}: any) => (
                                <TextField
                                    required
                                    fullWidth
                                    label={t('form.railwayStationTax')}
                                    select
                                    value={field.value}
                                    onChange={(e) => {
                                        field.onChange(e.target.value);
                                        if(watch(`${prefix}.railwayStationTax`) === 'Z' && watch(`${prefix}.airportTax`) === 'Z'){
                                            setValue(`${prefix}.airportRailwayStationTax`,'')
                                        }
                                    }}
                                    error={!!fieldState.error}
                                    helperText={fieldState.error?.message}
                                >
                                    {surchargesValues?.map((v) => (
                                        <MenuItem key={v.value} value={v.value}>
                                            {v.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            )}/>
                    </Grid>
                    <Grid item xs={3}>
                        <Controller
                            control={control}
                            name={`${prefix}.roadTax`}
                            render={({field,fieldState}: any) => (
                                <TextField
                                    required
                                    fullWidth
                                    label={t('form.roadTax')}
                                    select
                                    value={field.value}
                                    onChange={(e) => {
                                        field.onChange(e.target.value);
                                        if(watch(`${prefix}.roadTax`) === 'Z'){
                                            setValue(`${prefix}.roadTaxDailyValue`,'')
                                        }
                                    }}
                                    error={!!fieldState.error}
                                    helperText={fieldState.error?.message}
                                >
                                    {surchargesValues?.map((v) => (
                                        <MenuItem key={v.value} value={v.value}>
                                            {v.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            )}/>
                    </Grid>
                    <Grid item xs={3}>
                        <Controller
                            control={control}
                            name={`${prefix}.airportTax`}
                            render={({field,fieldState}: any) => (
                                <TextField
                                    required
                                    fullWidth
                                    label={t('form.airportTax')}
                                    select
                                    value={field.value}
                                    onChange={(e) => {
                                        field.onChange(e.target.value);
                                        if(watch(`${prefix}.railwayStationTax`) === 'Z' && watch(`${prefix}.airportTax`) === 'Z'){
                                            setValue(`${prefix}.airportRailwayStationTax`,'')
                                        }
                                    }}
                                    error={!!fieldState.error}
                                    helperText={fieldState.error?.message}
                                >
                                    {surchargesValues?.map((v) => (
                                        <MenuItem key={v.value} value={v.value}>
                                            {v.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            )}/>
                    </Grid>
                    <Grid item xs={3}/>
                    <Grid item xs={3}>
                        <Controller
                            control={control}
                            name={`${prefix}.airportRailwayStationTax`}
                            render={({field, fieldState}: any) => (
                                <TextField
                                    fullWidth
                                    label={t('form.airportRailwayStationTax')}
                                    value={field.value}
                                    disabled={watch(`${prefix}.railwayStationTax`) === 'Z' &&  watch(`${prefix}.airportTax`) === 'Z'}
                                    onChange={(e) => {
                                        if (e.target.value.length <= 2)
                                            field.onChange(e.target.value);
                                    }}
                                    type={'number'}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="start">%</InputAdornment>
                                    }}
                                    error={!!fieldState.error}
                                    helperText={fieldState.error?.message}
                                />
                            )}/>
                    </Grid>
                    <Grid item xs={3}>
                        <Controller
                            control={control}
                            name={`${prefix}.roadTaxDailyValue`}
                            render={({field, fieldState}: any) => (
                                <TextField
                                    fullWidth
                                    label={t('form.roadTaxDailyValue')}
                                    value={field.value}
                                    error={!!fieldState.error}
                                    helperText={fieldState.error?.message}
                                    disabled={watch(`${prefix}.roadTax`) === 'Z'}
                                    onChange={(e) => {
                                        if (e.target.value === "" || CURRENCY_REG_EXP.test(e.target.value) || e.target.value.startsWith(',') || e.target.value.startsWith('.')) {
                                            field.onChange(checkValueWithInterval(e.target.value, 0, 1000000))
                                        }
                                    }}
                                >
                                </TextField>
                            )}/>
                    </Grid>
                    <Grid item xs={3}>
                        <Controller
                            control={control}
                            name={`${prefix}.reservedPricing`}
                            render={({field}: any) => (
                                <TextField
                                    fullWidth
                                    label={t('form.reservedPricing')}
                                    select
                                    value={field.value}
                                    onChange={field.onChange}
                                >
                                    <MenuItem key={""} value={""}/>
                                    {reservationValues?.map((r) => (
                                        <MenuItem key={r.value} value={r.value}>
                                            {r.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            )}/>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    )
}
export default TaxConfigurationAccordion;